module.exports = __webpack_public_path__ + "img/product3.f51b47c3.png";